import Article from 'requests/objects/article'

/**
 * Merchandise
 */
export default class Merchandise {
    /**
     * @param {object} data data
     * @param {number=} data.merchandiseId merchandiseId
     * @param {boolean=} data.isManualArticle isManualArticle
     * @param {string=} data.merchandiseName articleName
     * @param {number=} data.orderQuoteId orderQuoteId
     * @param {number=} data.articleId articleId
     * @param {object=} data.article article
     * @param {string=} data.reference reference
     * @param {number=} data.weight weight
     * @param {number=} data.footage footage
     * @param {number=} data.long long
     * @param {number=} data.width width
     * @param {number=} data.height height
     * @param {number=} data.quantity quantity
     * @param {string=} data.comment ref
     */
    constructor({
        merchandiseId,
        isManualArticle = false,
        merchandiseName = '',
        orderQuoteId,
        articleId,
        article,
        reference = '',
        weight,
        footage,
        long,
        width,
        height,
        quantity,
        comment = '',
    }) {
        this.merchandiseId = merchandiseId
        this.isManualArticle = isManualArticle
        this.merchandiseName = merchandiseName
        this.orderQuoteId = orderQuoteId
        this.articleId = articleId
        this.article = article ? new Article(article) : null
        this.reference = reference
        this.weight = weight && !Number.isNaN(+weight) ? +weight : null
        this.footage = footage && !Number.isNaN(+footage) ? +footage : null
        this.long = long && !Number.isNaN(+long) ? +long : null
        this.width = width && !Number.isNaN(+width) ? +width : null
        this.height = height && !Number.isNaN(+height) ? +height : null
        this.quantity = quantity && !Number.isNaN(+quantity) ? +quantity : null
        this.comment = comment
    }
}
